module.exports = __webpack_public_path__ + "static/img/streamerIN.a224228.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/streamerIN.webp
// module id = Wyb7
// module chunks = 0